import React from 'react';
import Survey, { CssNames } from '../../Survey';
import PairRangeSurvey from './pair_range_distance';
import PairRangeWrapper from './pair_range.styles';

class PairRangeDistanceSurvey extends React.Component {
  _times = {};

  onComplete = async (survey, options) => {
    const { data } = survey;
    const { onComplete } = this.props;
    console.log({ data, times: this._times });
    const parsed = {
      ...data,
      ...this._times
    };
    await onComplete(parsed);
  };

  onValidate = async survey => {
    const { currentPage } = survey;
    const { questions } = currentPage;
    // const currentQuestion = questions.length > 2 ? questions[2] : questions[1];
    const currentQuestion = questions[0];
    const { name } = currentQuestion;
    const qstName = `${name}_TIME`;
    const qstTime = currentPage.timeSpent;
    console.log({ qstName, qstTime });

    this._times = { ...this._times, [qstName]: qstTime };
  };

  render() {
    const PairDistanceModel = new Survey.Model(PairRangeSurvey);
    PairDistanceModel.startTimer();
    return (
      <PairRangeWrapper>
        <div className='edu_header'>
          <img
            className='edu-logo'
            src='https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png'
            alt='edu-logo'
          />
        </div>
        <Survey.Survey
          model={PairDistanceModel}
          css={CssNames}
          onComplete={this.onComplete}
          onValidatedErrorsOnCurrentPage={this.onValidate}
        />
        <div className='Footer'>
          {/* <img
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629089/uaimetrics/Logo_edu-corporate-2.png"
            alt="edu-corporate"
          /> */}
          {/* <img
            className="btg-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629090/uaimetrics/BTG-Pactual-HP_Logo.jpg"
            alt="btg-pactual"
          /> */}
        </div>
        <div className='PushStickyFooter'></div>
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </PairRangeWrapper>
    );
  }
}

export default PairRangeDistanceSurvey;
